// A ‘.tsx’ file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
import SystemStoreClass from './../../../stores/SystemStore';
import SystemActions from './../../../actions/SystemActions';
import SystemConstants from './../../../constants/SystemConstants';
import ModalPopUp from './../ModalPopUp';
import Warning from './Warning';
import Error from './Error';
import Confirmation from './Confirmation';
import Success from './Success';
import Info from './Info';
import ConfirmUserChanges from './ConfirmUserChanges';
import ConfirmYesNo from './ConfirmYesNo';
var SystemStore = SystemStoreClass;

interface MessageBoxProps {
}

interface MessageBoxState {
    messages: any;
    count: number;
    focusedElement?: any;
}

function getMessageBoxState(): MessageBoxState {
    return {
        messages: SystemStore.getMessages(),
        count: SystemStore.getMessageCount()
    };
}

class MessageBox extends React.Component<MessageBoxProps, MessageBoxState> {

    constructor(props: MessageBoxProps) {
        super(props);

        this.state = getMessageBoxState();
    }

    private _change = () => {
        this.setState(getMessageBoxState());
    }

    private _onClose = (key: string, callback?: any) => {
        SystemActions.PublicActions.removeMessage(key);
        if (callback) {
            callback();
        }
    }

    private _renderMessage = (key: any, msgContainer: any) => {
        if (msgContainer.type == SystemConstants.MessageType.Warning) {
            return <Warning onClick={() => this._onClose(key, msgContainer.msgObj.confirmCallback)} message={msgContainer.msgObj.message} key={key} />;
        } else if (msgContainer.type == SystemConstants.MessageType.Confirmation) {
            return <Confirmation onClick={() => this._onClose(key)} message={msgContainer.msgObj.message} confirmationCallback={msgContainer.msgObj.confirmCallback}
                cancelCallback={msgContainer.msgObj.cancelCallback} key={key} />;
        } else if (msgContainer.type == SystemConstants.MessageType.Error) {
            return <Error onClick={() => this._onClose(key, msgContainer.msgObj.confirmCallback)} message={msgContainer.msgObj.message} heading={msgContainer.msgObj.heading} errorId={msgContainer.msgObj.errorId} helpLink={msgContainer.msgObj.helpLink} key={key} />;
        } else if (msgContainer.type == SystemConstants.MessageType.Info) {
            return <Info onClick={() => this._onClose(key, msgContainer.msgObj.confirmCallback)} message={msgContainer.msgObj.message}
                heading={msgContainer.msgObj.heading} messageHasTags={msgContainer.msgObj.messageHasTags} key={key} />;
        } else if (msgContainer.type == SystemConstants.MessageType.Success) {
            return <Success onClick={() => this._onClose(key, msgContainer.msgObj.confirmCallback)} message={msgContainer.msgObj.message} key={key} />;
        } else if (msgContainer.type == SystemConstants.MessageType.ConfirmUserChanges) {
            return <ConfirmUserChanges cancelCallback={() => this._onClose(key)} message={msgContainer.msgObj.message}
                confirmationCallback={msgContainer.msgObj.confirmCallback} discardCallback={msgContainer.msgObj.cancelCallback} key={key} />;
        } else if (msgContainer.type == SystemConstants.MessageType.YesNo) {
            return <ConfirmYesNo onClick={() => this._onClose(key)} message={msgContainer.msgObj.message} yesCallback={msgContainer.msgObj.confirmCallback}
                noCallback={msgContainer.msgObj.cancelCallback} messageHasTags={msgContainer.msgObj.messageHasTags} key={key} />;
        }
    }

    private _clearFocus = () => {
        if (this.state.count > 0) {
            if (document.activeElement && (document.activeElement != this.state.focusedElement)) {
                try {
                    this.setState({ focusedElement: document.activeElement });
                    (document.activeElement as any).blur();
                } catch (e) {

                }
            }
        } else {
            if (this.state.focusedElement) {
                this.state.focusedElement.focus();
                this.setState({ focusedElement: null });
            }
        }
    }

    componentDidMount() {
        this._clearFocus();
        SystemStore.addChangeListener(this._change);
    }

    componentDidUpdate() {
        this._clearFocus();
    }

    componentWillUnmount() {
        SystemStore.removeChangeListener(this._change);
    }

    render() {
        var messages = Object.keys(this.state.messages).map((key) => {
            return this._renderMessage(key, this.state.messages[key]);
        });
        return (
            <ModalPopUp isOpen={this.state.count > 0}>
                {messages}
            </ModalPopUp>
        );
    }
}

export default MessageBox;
